import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { SafetyRatingReviewRoutes } from "../../constants/vetting/vetting.constants";
import { SafetyRatingReviewClientModel, SafetyRatingReviewTaskClientModel } from "../../models/vetting/vetting.models";
import { GetListItemResponse } from "../../models/lists/list.models";

@autoinject
export class SafetyRatingReviewService {
    
    constructor(private requestClient: RequestClientService) {
    }

    public getListItems(safetyRatingReviewTaskId: number): GetListItemResponse[] | PromiseLike<GetListItemResponse[]> {
        return this.requestClient.get<GetListItemResponse[]>(`${SafetyRatingReviewRoutes.GetListItems}/${safetyRatingReviewTaskId}`, {});
    }
    
    public getSafetyRatingReview(id: number, includeTasks: boolean): Promise<SafetyRatingReviewClientModel> {
        return this.requestClient.get(`${SafetyRatingReviewRoutes.GetSafetyRatingReview}/${id}`, { includeTasks: includeTasks });
    }

    public getSafetyRatingReviewTasks(id: number): Promise<SafetyRatingReviewTaskClientModel[]> {
        return this.requestClient.get(`${SafetyRatingReviewRoutes.GetSafetyRatingReviewTasks}/${id}`, {});
    }

    public updateTaskOutcome(taskId: number, outcome: number): Promise<void> {
        return this.requestClient.post(`${SafetyRatingReviewRoutes.UpdateSafetyRatingReviewTaskOutcome}/${taskId}`, {}, {
            outcome: outcome
        });
    }

    public changeStatus(id: number, statusId: number, comments: string, meta: string, subtaskTypes: number[], statusSnippet: string, correspondenceToRequestors:string): Promise<void> {
        return this.requestClient.post(SafetyRatingReviewRoutes.ChangeStatus, {}, {
            id: id,
            message: correspondenceToRequestors,
            comments: comments,
            statusId: statusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            statusSnippet: statusSnippet
        });
    }

    public rerunRules(id: number,safetyReviewId:number): Promise<void> {
        return this.requestClient.post(`${SafetyRatingReviewRoutes.ReRunRules}/${id}/${safetyReviewId}`, {}, {});
    }

    public saveComments(safetyRatingReviewId: number, taskComments: { vettingComment: string; safetyRatingReviewTaskId: number; }[], otherComments: string): Promise<void> {
        return this.requestClient.post(`${SafetyRatingReviewRoutes.SaveSafetyRatingReviewComments}`, {}, {
            safetyRatingReviewId: safetyRatingReviewId,
            taskComments: taskComments,
            otherComments: otherComments
        });
    }
}
